import { get } from '@/helpers';

export const sortingOrders = {
    color: [],
    size: [
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '37/38',
        '38',
        '39',
        '39/40',
        '40',
        '41',
        '41/42',
        '42',
        '43',
        '43/44',
        '44',
        '45',
        '45/46',
        '46',
        '47',
        '48',
        '49',
        '50',
        '52',
        '54',
        '55',
        '56',
        '58',
        '60',
        '62',
        '64',
        '65',
        '66',
        '68',
        '70',
        '74',
        '75',
        '80',
        '85',
        '86',
        '88',
        '90',
        '92',
        '94',
        '95',
        '98',
        '100',
        '102',
        '104',
        '105',
        '106',
        '110',
        '114',
        '116',
        '118',
        '120',
        '122',
        '122.5',
        '128',
        '128.5',
        '1285',
        '128½+',
        '130',
        '134',
        '1345',
        '134.5',
        '134.5+',
        '13405',
        '140',
        '140.5',
        '140.5+',
        '1405',
        '146',
        '146.5',
        '146.5+',
        '1465',
        '152',
        '152.5',
        '152.5+',
        '1525',
        '158',
        '158.5',
        '158.5+',
        '1585',
        '164',
        '164.5',
        '164.5+',
        '1645',
        '170',
        '170.5',
        '170.5+',
        '1705',
        '176',
        '176.5',
        '176.5+',
        '1765',
        '182',
        '182.5',
        '182.5+',
        '1825',
        '188',
        'Gr. 0',
        'Gr. 1',
        'Gr. 2',
        'XS',
        'S',
        'PL',
        'Lg 0',
        'Lg 01',
        'Lg 1',
        'Lg 2',
        'Lg 3',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL'
    ]
};

export const getShippingFee = (shippingMethod, net = false) => {
    let fee = 0;
    switch (shippingMethod.price_type) {
        case 'flat-rate': {
            let key = 'value';
            if (net) key = 'net_value';
            fee = get(shippingMethod, `mainPrice.${key}`, 0);
            break;
        }

        case 'country':
            // TODO
            break;

        // TODO
        // process other price types
    }
    return fee;
};

export const getPropertyValues = pivot => {
    const property = pivot?.property;
    const valueField = pivot?.property?.propType?.value_field;
    const valueFieldAlt = pivot?.property?.propType?.value_field_alt;

    const values = pivot?.values || [];
    // return values.map(el => ({ label: property.name, value: el[valueField] || el[valueFieldAlt] }))

    return { label: property?.name, values: values.map(el => el[valueField] || el[valueFieldAlt]) };
};
